import { useContext, useEffect, useState } from 'react';
import RentalDetails from './RentalDetails';
import RentalDepositOptions from './RentalDepositOptions';
import RentalDate from './RentalDate';
import useTranslator from '../../hooks/useTranslator';
import { useNavigate, useParams } from 'react-router-dom';
import constants from '../../Utils/constants';
import AuthContext from '../../context/auth/AuthContext';
import TenantContext from '../../context/tenant/TenantContext';
import CardSelect from './CardSelect';
import { toast } from '../../helper/common';

const RentalSetup = (props) => {
  const navigate = useNavigate();
  const { _t } = useTranslator();

  const [step, setStep] = useState(0);
  const { assignedPropertyId } = useParams();
  const { formData, setFormData } = props;
  const [cardModal, setCardModal] = useState(false);
  const [isDomesticCard, setIsDomesticCard] = useState(null);
  const authContext = useContext(AuthContext);
  const { setLoading } = authContext;
  const tenantContext = useContext(TenantContext);
  const { checkUelzStatus, createTransactionLedger } = tenantContext;
  const queryParameters = new URLSearchParams(window.location.search);
  const paramSuccess = queryParameters.get('success');

  const handleNextStep = () => {
    setStep((prev) => prev++);
  };

  useEffect(() => {
    if (paramSuccess == true || paramSuccess == 'true') {
      navigate(`/review/rental/${formData?._id}`);
    } else if (paramSuccess == false || paramSuccess == 'false') {
      toast.error(_t('paymentFailed'));
    }
  }, []);

  const checkSuccessPayload = () => {
    setLoading(true);
    checkUelzStatus(formData?._id)
      .then((res) => {
        if (res?.success_res?.data?.status == constants.COMPLETED) {
          setLoading(false);
          navigate(`/review/rental/${formData?._id}`);
        } else {
          checkSuccessPayload();
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const handleNavigate = async () => {
    const formData = {
      assignedPropertyId,
      isDomesticCard,
    };
    createTransactionLedger(formData)
      .then((res) => {
        if (res.success) {
          window.location.replace(res.success_res.session.url);
        }
      })
      .catch((err) => {
        console.log(err);
      });
    // navigate(`/review/rental/${formData?._id}`);
  };

  return (
    <>
      <div className="foursteps-sec">
        <RentalDetails
          formData={formData}
          step={step}
          handleNextStep={handleNextStep}
          setStep={setStep}
        />

        <RentalDepositOptions
          formData={formData}
          step={step}
          handleNextStep={handleNextStep}
          setStep={setStep}
          setFormData={setFormData}
        />

        <RentalDate
          formData={formData}
          step={step}
          handleNextStep={handleNextStep}
          setStep={setStep}
          setFormData={setFormData}
        />

        <div className="three-rentpayment-sec mobile-depositoptions">
          <div className="skorprotect-sec">
            {step == 2 ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
              >
                <circle cx="16" cy="16" r="16" fill="#7F7F7F" />
                <path
                  d="M11.8654 20.314L7.93019 16.4506C7.71814 16.2425 7.43055 16.1255 7.13068 16.1255C6.8308 16.1255 6.54321 16.2425 6.33117 16.4506C6.11912 16.6588 6 16.9412 6 17.2356C6 17.3813 6.02925 17.5257 6.08607 17.6604C6.14289 17.795 6.22617 17.9174 6.33117 18.0205L11.0715 22.6743C11.5138 23.1086 12.2283 23.1086 12.6705 22.6743L24.6688 10.895C24.8809 10.6868 25 10.4044 25 10.11C25 9.81564 24.8809 9.5333 24.6688 9.32512C24.4568 9.11695 24.1692 9 23.8693 9C23.5695 9 23.2819 9.11695 23.0698 9.32512L11.8654 20.314Z"
                  fill="white"
                />
              </svg>
            ) : (
              <p className="third-count">4</p>
            )}

            <h3 className="rental_detail_heading">{_t('skorProtect')}</h3>
          </div>
          <div>
            <p className="comingsoon-content"> {_t('comingSoon')} </p>
          </div>
        </div>
       
        {step == 2 && (
          <button
            className="btn btngreen  complete-pay"
            onClick={() => setCardModal(true)}
          >
            {_t('completePayment')}
          </button>
        )}
      </div>
      {cardModal && (
        <CardSelect
          cardModal={cardModal}
          setCardModal={setCardModal}
          setIsDomesticCard={setIsDomesticCard}
          isDomesticCard={isDomesticCard}
          proceedPayment={handleNavigate}
        />
      )}
    </>
  );
};

export default RentalSetup;
